<template>
  <div class="navbar-header d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <b-link
          class="navbar-brand"
          :to="logoHomeRoute"
        >
          <span class="brand-logo">
            <b-img
              :src="appLogoImage"
              alt="logo"
            />
          </span>
          <h2 class="brand-text mb-0">
            {{ appName }}
          </h2>
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { $themeConfig } from '@themeConfig'
import store from '@/store'

export default {
  components: {
    BLink,
    BImg,
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    const logoHomeRoute = computed(() =>
      store.state.app.isAdmin ? { name: 'admin-dashboard' } : { name: 'home' }
    )
    return {
      appName,
      appLogoImage,
      logoHomeRoute,
    }
  },
}
</script>

<style>

</style>
